import React from 'react';
import { Box, Tooltip } from '@mui/material';
import SnackbarUtils from '../../../../utils/SnackbarUtils';

const CopyToClipboardCell = props => {
  const copyText = value => e => {
    e.stopPropagation();
    const el = document.createElement('textarea');
    el.innerText = value;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    el.remove();
    SnackbarUtils.success('Value has been copied to clipboard!');
  };
  return (
    <>
      <Tooltip title='Copy to clipboard' arrow>
        <span>
          <Box onClick={copyText(props.value)}>
            <i className={'fa fa-clipboard'} style={{ pointerEvents: 'none', marginRight: '5px' }} />
          </Box>
        </span>
      </Tooltip>
    </>
  );
};

export default React.memo(CopyToClipboardCell);
CopyToClipboardCell.whyDidYouRender = true;
